import { createStackNavigator } from "@react-navigation/stack";

// Data
import { Entity, InsightID } from "../types/data";

// Screens
import Observations from "../screens/Observations";
import Insight from "../screens/Insight";
import Compare from "../screens/Compare";
import TabNavigator from "./TabNavigator";

export type RootStackParamList = {
  Tabs: undefined;
  Insight: { id: InsightID };
  Observations: { id: InsightID };
  Compare: { id: InsightID };
};

const Stack = createStackNavigator<RootStackParamList>();

const StackNavigator = () => {
  return (
    <Stack.Navigator
      screenOptions={{
        headerShown: false,
        // animationEnabled: false,
        animationTypeForReplace: "pop",
      }}
    >
      <Stack.Screen name="Tabs" component={TabNavigator} />
      <Stack.Screen name="Insight" component={Insight} />
      <Stack.Screen name="Observations" component={Observations} />
      <Stack.Screen name="Compare" component={Compare} />
    </Stack.Navigator>
  );
};

export default StackNavigator;
